<template>
  <button class="bg-accent rounded-lg py-3 hover:bg-accent/90">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "VButton"
}
</script>

<style scoped>

</style>